import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-node-plus",
  "use": "icon-node-plus-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-node-plus\"><defs><style>#icon-node-plus .a{fill:#5686f1;}</style></defs><path class=\"a\" d=\"M109.462,102.462h-5.923V96.538a.538.538,0,1,0-1.077,0v5.923H96.538a.538.538,0,1,0,0,1.077h5.923v5.923a.538.538,0,0,0,1.077,0v-5.923h5.923a.538.538,0,0,0,0-1.077Z\" transform=\"translate(-96 -96)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol